import { Expose, Type, Exclude } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnObjectInfo } from '../base';
import { SnOrganization } from '../organization';
import { SnShareDirection } from './share-direction';
import { SnSharePermissions } from './share-permissions';
import { SnSharePermissionsDetails } from './share-permissions-details';
import { SnShareStatus } from './share-status';

export class SnShare extends SnModel {
  @Expose()
  @Exclude({ toPlainOnly: true })
  public id: string;

  @Expose()
  public permissions: SnSharePermissions;

  @Expose()
  public permissionsDetails: SnSharePermissionsDetails;

  @Expose()
  public isEnabled: boolean;

  @Expose()
  public color: string;

  @Expose()
  public isAdminOnly: boolean;

  @Expose()
  @Exclude({ toPlainOnly: true })
  public readonly direction: SnShareDirection;

  @Expose()
  @Exclude({ toPlainOnly: true })
  public isAccepted: boolean;

  @Expose({ name: 'objectInfo' })
  @Exclude({ toPlainOnly: true })
  @Type(() => SnObjectInfo)
  public readonly object: SnObjectInfo;

  @Expose({ name: 'sourceOrganization' })
  @Type(() => SnOrganization)
  @Exclude({ toPlainOnly: true })
  public readonly ownerOrganization: SnOrganization;

  @Expose({ name: 'targetOrganization' })
  @Type(() => SnOrganization)
  @Exclude({ toPlainOnly: true })
  public readonly sharerOrganization: SnOrganization;

  @Expose({ name: 'createdTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public createdAt: Date;

  @Expose()
  public isRestricted: boolean;

  @Expose()
  public userChangeOwner: boolean;

  @Expose()
  @Type(() => Date)
  public startDate: Date;

  @Expose()
  @Type(() => Date)
  public endDate: Date;

  public readonly status: SnShareStatus;

  public readonly isIn: boolean;
  public readonly isOut: boolean;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);

    this.isIn = this.direction === SnShareDirection.In;
    this.isOut = this.direction === SnShareDirection.Out;

    this.status = this._getStatus();
  }

  private _getStatus(): SnShareStatus {
    if (this.isAccepted) {
      return SnShareStatus.Accepted;
    } else if (this.isIn) {
      return SnShareStatus.Unaccepted;
    } else if (this.isOut) {
      return SnShareStatus.Pending;
    }
  }
}
